
import React, { useState } from 'react';

import s from './FormNormal.module.scss';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2'


//Material
import {
    Grid,
    TextField,
    Button
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';



const FormNormal = () => {
    const [form, setForm] = useState({
        name: '',
        lastname: '',
        email: '',
        phone: '',
        message: '',
    })
    const[error, setErrors] = useState({});


    const expresionDate = {
        name: /^[a-zA-Z]{3,20}$/, 
        email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        number: /^\d+$/
    }

    const validateField = (fieldName, value) => {
        let errorMessage = '';

        if (fieldName === 'name') {
            if (!value.trim()) {
                errorMessage = 'Por favor, agrega un Nombre';
            } else if (!expresionDate.name.test(value.trim())) {
                errorMessage = 'Por favor ingresa un Nombre de entre 3 y 20 caracteres';
            }
            
        } else if (fieldName === 'lastname') {
            if (!value.trim()) {
                errorMessage = 'Por favor, agrega un Apellido';
            } else if (!expresionDate.name.test(value.trim())) {
                errorMessage = 'Por favor ingresa un Apellido de entre 3 y 20 caracteres';
            }
        } else if (fieldName === 'email') {
            if (!value) {
                errorMessage = 'Por favor ingresa un Email';
            } else if (!expresionDate.email.test(value)) {
                errorMessage = 'Por favor ingresa un Email válido';
            }
        } else if (fieldName === 'phone') {
            if (!value) {
                errorMessage = 'Por favor, ingresa un número de teléfono';
            } else if (!expresionDate.number.test(value)) {
                errorMessage = 'Por favor, ingresa solo números';
            }
        } else if (fieldName === 'message') {
            if (!value) {
                errorMessage = 'Por favor ingresa un mensaje';
            }
        }

        return errorMessage;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        const errorMessage = validateField(name, value);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));

        setForm((prevForm) => ({
            ...prevForm,
            [name]: value,
        }));
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        const errorMessage = validateField(name, value);
    
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));
    
        if (errorMessage) {
            e.target.classList.add('error-input');
        } else {
            e.target.classList.remove('error-input');
        }
    };

    console.log("formulario", form)




    const handleEmailSubmit = (e) => {
        e.preventDefault();

        const validationErrors = {};
        Object.keys(form).forEach((fieldName) => {
            const errorMessage = validateField(fieldName, form[fieldName]);
            if (errorMessage) {
                validationErrors[fieldName] = errorMessage;
            }
        });

        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
            const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
            const userID = process.env.REACT_APP_EMAILJS_USER_ID;
            
            const emailData = {
                Nombre: form.name,
                Apellido: form.lastname,
                message: form.message,
                Email: form.email,
                Tel: form.phone,
            };
            emailjs.send(serviceID, templateID, emailData, userID)
            .then((response) => {
                console.log('Correo electrónico enviado correctamente:', response.status);
                if(response.status === 200){
                Swal.fire({
                    html:'Tu mensaje se envio correctamente',
                    icon: 'success',
                    padding:'1rem 3rem',
                    grow:'row',
                    toast:true,
                    position:'bottom',
                    allowEscapeKey:'false',
                    showConfirmButton: false,
                    timer: 4000,
                    timerProgressBar: true,
                    customClass: {
                        popup: 'swal-custom-popup' // Agrega una clase personalizada para aplicar estilos
                    }
                })
                }
                // Realiza acciones adicionales después del envío exitoso, como mostrar un mensaje de éxito al usuario.
            })
            .catch((error) => {
                console.error('Error al enviar el correo electrónico:', error);
                // Realiza acciones adicionales en caso de error, como mostrar un mensaje de error al usuario.
            });
        } else{
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    html: 'Por favor, revisa los errores antes de enviar el formulario!',
                });
        };
    } 

    return (
        <Grid item xs={12} container className={s.container}>
            <Grid item xs={10} md={9} lg={6.5} sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', mt: 3}}>  
                <h4 style={{margin: 0, fontSize: '1.5rem', fontWeight: 600, color:"#303030"}}>Formulario de contacto</h4>
                <p style={{margin: 0, marginTop: '5px', fontSize: '1.1rem', fontWeight: 400, color:"#303030"}}>Comunicate para conocer más sobre nuestros productos y servicios</p>
            </Grid>

            <Grid item container xs={10} md={9} lg={6.5} id="form" className={s.form}>
                <Grid item xs={12} md={5.8} lg={5.8}>
                    <p style={{fontSize: '0.9rem', color:"#303030"}}>Nombre</p>
                    <TextField 
                        value={form.name} 
                        name="name"
                        onChange={handleChange}
                        onBlur={handleBlur} 
                        error={!!error.name} 
                        helperText={error.name}
                        sx={{width: '100%'}}
                    />
                </Grid>
                <Grid item xs={12} md={5.8} lg={5.8}>
                    <p style={{fontSize: '0.9rem', color:"#303030"}}>Apellido</p>
                    <TextField 
                        type={"text"}
                        value={form.lastname}
                        name="lastname"
                        onChange={handleChange}
                        onBlur={handleBlur} 
                        error={!!error.lastname} 
                        helperText={error.lastname}
                        sx={{width: '100%'}}
                    />
                
                </Grid>
                <Grid item xs={12} md={5.8} lg={5.8}>
                    <p style={{fontSize: '0.9rem', color:"#303030"}}>Email</p>
                    <TextField 
                        value={form.email} 
                        name="email"
                        onChange={handleChange}
                        onBlur={handleBlur} 
                        error={!!error.email} 
                        helperText={error.email}
                        sx={{width: '100%'}}
                    />

                </Grid>
                <Grid item xs={12} md={5.8} lg={5.8}>
                    <p style={{fontSize: '0.9rem', color:"#303030"}}>Teléfono</p>
                    <TextField 
                        value={form.phone} 
                        name="phone"
                        onChange={handleChange}
                        onBlur={handleBlur} 
                        error={!!error.phone} 
                        helperText={error.phone}
                        sx={{width: '100%'}}
                    />
                
                </Grid>

                <Grid item xs={12} >
                    <p style={{fontSize: '0.9rem', color:"#303030"}}>Mensaje</p>
                    <TextField
                        fullWidth
                        value={form.message}
                        name="message"
                        onChange={handleChange}
                        onBlur={handleBlur} 
                        error={!!error.message} 
                        helperText={error.message}
                        multiline
                        rows={6}
                    />
                </Grid>
            </Grid>

            <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', borderColor: "black", marginBottom: '5vh', marginTop: '5vh'}}>
                <Button 
                    id="button" 
                    variant='contained' 
                    color='error' 
                    type='submit' 
                    onClick={handleEmailSubmit} 
                    style={{padding: '0px 40px'}}
                >
                    <p style={{fontSize: '0.8rem', fontWeight: 700}}>Enviar</p>
                    <ArrowForwardIosIcon sx={{fontSize: '1.3rem', color: 'white'}}/>
                </Button>
            </Grid>
            
        </Grid>
    )
}

export default FormNormal;